import { OfferingSearchRequestQuery } from '@lio/api-types';

export const getOfferingsQuery = (params: OfferingSearchRequestQuery) => {
  const { pageLimit, pageOffset, sort, insuranceProductId, writingCompanyId } = params;
  const query = new URLSearchParams();
  if (pageLimit) {
    query.append('pageLimit', String(pageLimit));
  }
  if (pageOffset) {
    query.append('pageOffset', String(pageOffset));
  }
  if (sort) {
    query.append('sort', sort);
  }
  if (insuranceProductId) {
    query.append('insuranceProductId', insuranceProductId);
  }
  if (writingCompanyId) {
    query.append('writingCompanyId', writingCompanyId);
  }
  return query.toString();
};
